import { render, staticRenderFns } from "./v-datetime-field.vue?vue&type=template&id=80b7060c&scoped=true&"
import script from "./v-datetime-field.vue?vue&type=script&lang=js&"
export * from "./v-datetime-field.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80b7060c",
  null
  
)

export default component.exports